import {NgModule} from "@angular/core";
import {CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClient} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HashLocationStrategy, LocationStrategy} from "@angular/common";

import {ModalModule} from "ngx-bootstrap/modal";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {UnauthorizeComponent} from "./unauthorize/unauthorize.component";
import {FlexLayoutModule} from "@angular/flex-layout";
import {LoginComponent} from "./login/login.component";


// Shared
import {TDateFormatPipe} from "../shared/pipe/date-formate.pipe";
import {TOnlyDateFormatPipe} from "../shared/pipe/date-only-formate.pipe";
import {HttpInterceptorService} from "../shared/interceptor/http-interveptor";
import {SharedModule} from "src/shared/components/shared.module";
import {ToastrService} from "ngx-toastr";
import {ToastrComponent} from "src/shared/components/toastr/toastr.component";
import {FlutterwaveModule} from "flutterwave-angular-v3";
import {WebcamModule} from "ngx-webcam";
import {ConfirmDialogService} from "src/shared/components/confirm-dialog/confirm-dialog.service";
import {PageLoaderService} from "src/shared/components/page-loader/page-loader.service";
import {AlertDialogService} from "src/shared/components/alert-dialog/alert-dialog.service";
import {NgChartsModule} from "ng2-charts";
import {DeviceManagementService} from "./app.global.service";
import {ConfirmLogoutDialogService} from "src/shared/components/confirm-logout-dialog/confirm-logout-dialog.service";
import { PortraitCaptureAlertDialogService } from "src/shared/components/portrait-capture-alert-dialog/portrait.capture.alert.dialog.service";
import { PortraitCaptureHintCardService } from "src/shared/components/portrait-capture-hint-card/portrait.capture.hint.card.service";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UnauthorizeComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    NgChartsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    FlexLayoutModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
    FlutterwaveModule,
    WebcamModule
  ],
  providers: [
    HttpClientModule,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {provide: ToastrService, useValue: ToastrComponent},
    // FlutterwaveService,
    TDateFormatPipe,
    TOnlyDateFormatPipe,
    ConfirmDialogService,
    ConfirmLogoutDialogService,
    AlertDialogService,
    PortraitCaptureAlertDialogService,
    PageLoaderService,
    DeviceManagementService,
    PortraitCaptureHintCardService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
